<template>
    <div>
        <plt-page-title>电子运单列表</plt-page-title>
        <div style="margin: 30px 10px">
            <el-input v-model="eWaybillQueryParam.businessNo" placeholder="请输入发运编号" style="width: 200px; margin-right: 30px" clearable />
            <plt-dict-select v-model="eWaybillQueryParam.toMemberId" namespace="bizObjects" id="member" :include="includeList" style="margin-right: 30px" />
            <el-button type="primary" @click="$refs['dg'].loadFirstPage()">查看</el-button>
            <el-button type="info" @click="downloadReceiptFiles" style="margin-left: 30px" :loading="loading" >下载签收单</el-button>
        </div>

        <plt-table ref="dg" url="MID-OPERATE-LOGISTICS/messageService/eWaybillService/queryEWayBillsByMember" exportId="zh_ewaybill" exportFileName="电子运单列表.csv"
                :queryParams="eWaybillQueryParam" paramName="eWaybill" >

            <template #table="{data, pageSize, pageNum}"  > 
                <el-table :data="data" border size="mini" highlight-current-row @current-change="clickCustomerRow"  >
                    <el-table-column label="#" width="40" fixed align="center" type="index" :index="(index) => index + pageSize * (pageNum - 1) + 1" />
                    <el-table-column prop="eWaybillId" label="电子运单ID" width="150" fixed />
                    <el-table-column prop="businessNo" label="发运编号" width="150" />
                    <el-table-column prop="productName" label="货品名称" width="120" />
                    <!-- <el-table-column prop="productQuantity" label="货品数量" width="100" /> -->
                    <plt-table-dict-col prop="fromMemberId" label="发货客户" width="200" namespace="bizObjects" id="member" />
                    <plt-table-dict-col prop="toMemberId" label="收货客户" width="200" namespace="bizObjects" id="member" />
                    <el-table-column label="操作" width="100px">
                        <template #default="{row}">
                            <el-button type="warning" v-if="row.handoverFlag" size="mini" @click="checkReceipts(row.businessNo,row.masterMemberId)">查看</el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </template>
        </plt-table>
    </div>
</template>
<script>

export default {
    data() {
        return {
            eWaybillQueryParam: {
                masterMemberId: '',
                toMemberId: '',
                businessNo: ''
            },
            includeList: [],
            loading: false
        }
    },
    created() {
        this.eWaybillQueryParam.masterMemberId = sessionStorage.getItem("memberId");
        this.getIncludeLeasee();
    },   
    methods: {
        checkReceipts(businessNo, masterId){
            this.$router.push({path:"/user-center/lease/e-receipt-notes",query:{businessNo,masterId,backPath:'/user-center/lease/ewaybill'}})
        },
        async getIncludeLeasee() {
            let url = 'http://MID-OPERATE-LEASE/messageService/zhService/queryZHLeasees';
            this.includeList = await this.invoke(url, {});
        },     
        downloadReceiptFiles() {
            let param = {
                eWaybill: this.eWaybillQueryParam
            }
            let url = "MID-OPERATE-LOGISTICS/messageService/eWaybillService/downloadReceipts";

            this.loading = true
            this.invoke(url, param).then(fileId => {
                window.location.href = this.pltUtil.downloadUrl() + fileId;
            }).finally(() => this.loading = false)
        }   
    }    
}
</script>